import axios from 'axios'

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
})

const clientAPI = axios.create({
    baseURL: process.env.REACT_APP_CLIENT_API_BASE_URL
})
const headers = {
    uid: localStorage.getItem('--atomicly-uid'),
    Authorization: `Bearer ${localStorage.getItem('--atomicly-token')}`
}

export const test = payload => api.post(`/test`, payload, {headers: headers})

export const getLatestUpdate = payload => api.get(`/updates/latest/`, { headers: headers })
export const getMinVersion = (id, payload) => api.get(`/min-version/${id}`, { params: payload, headers })
export const uploadImg = payload => api.post('/upload-img/', payload, { headers: headers })

// Item
export const getItems = payload => api.get(`/items/`, {params: payload, headers: headers})
export const getItem = id => api.get(`/item/${id}`, {headers: headers})
export const createItem = payload => api.post(`/item`, payload, {headers: headers})
export const updateItem = (id, payload) => api.put(`/item/${id}`, payload, {headers: headers})
export const updateManyItems = payload => api.put('/items/update', payload, {headers: headers})
export const deleteItem = (id, payload) => api.delete(`/item/${id}`, {params: payload, headers: headers})
export const deleteItems = payload => api.delete(`/items/`, {params: payload, headers: headers})
export const createItems = payload => api.post(`/items/create`, payload, {headers: headers})
export const countUserItems = payload => api.get(`/items/user-count`, {params: payload, headers: headers})
export const countItems = payload => api.get(`/items/count`, {params: payload, headers: headers})

// Section
export const getSections = payload => api.get(`/sections`, {params: payload, headers: headers})
export const getSection = id => api.get(`/section/${id}`, {headers: headers})
export const createSection = payload => api.post(`/section`, payload, {headers: headers})
export const updateSection = (id, payload) => api.put(`/section/${id}`, payload, {headers: headers})
export const deleteSection = (id, payload) => api.delete(`/section/${id}`, {params: payload, headers: headers})
export const createSections = payload => api.post(`/sections`, payload, {headers: headers})

// Page
export const loadPage = (id, payload) => api.get(`/load_page/${id}`, {params: payload, headers: headers})
export const getPages = (payload) => api.get(`/pages`, {params: payload, headers: headers})
export const getPage = id => api.get(`/page/${id}`, {headers: headers}) 
export const createPage = payload => api.post(`/page`, payload, {headers: headers})
export const createPageTemplate = payload => api.post(`/page-template`, payload, {headers: headers})
export const updatePage = (id, payload) => api.put(`/page/${id}`, payload, {headers: headers})
export const deletePage = (id, payload) => api.delete(`page/${id}`, {params: payload, headers: headers})
export const countPages = payload => api.get(`/pages/count`, {params: payload, headers: headers})

// User
export const getUser = id => api.get(`/user/${id}`, {headers: headers})
export const loadUser = (userId, token) => api.get(`/load_user/${userId}`, {headers: {
    Authorization: `Bearer ${token || localStorage.getItem('--atomicly-token')}`, 
    uid: userId || localStorage.getItem('--atomicly-uid')
}})
export const loadUserExt = (payload) => api.get(`/load_user_ext/`, {
    params: payload,
    headers: {
        Authorization: `Bearer ${payload.token || localStorage.getItem('--atomicly-token')}`, 
        uid: payload.userId || localStorage.getItem('--atomicly-uid')
    }
})
export const getUserData = id => api.get(`/user-data/${id}`, {headers: headers})
export const createUser = payload => api.post(`/user`, payload, {headers: headers})
export const updateUser = (id, payload) => api.put(`/user/${id}`, payload, {headers: headers})
export const deleteUser = id => api.delete(`/user/${id}`, {headers: headers})

export const resetPassword = payload => api.post('/auth/reset-password', payload, { headers })

// Tag
export const getTag = id => api.get(`/tag/${id}`, {headers: headers})
export const createTag = payload => api.post(`/tag`, payload, {headers: headers})
export const updateTag = (id, payload) => api.put(`/tag/${id}`, payload, {headers: headers})
export const deleteTag = id => api.delete(`/tag/${id}`, {headers: headers})
export const getTags = payload => api.get(`/tags`, {params: payload, headers: headers})

// Focus
export const createFocus = payload => api.post(`/focus`, payload, {headers: headers})
export const getFocus = payload => api.get(`/focus`, {params: payload, headers: headers})
export const updateFocus = (id, payload) => api.put(`/focus/${id}`, payload, {headers: headers})
export const deleteFocus = id => api.delete(`/focus/${id}`, {headers: headers})
export const massFocus = payload => api.put('/focuses/many', payload, {headers: headers})

// Schedule
// export const createSchedule = payload => api.post(`/schedule`, payload, {headers: headers})
// export const getSchedule = payload => api.get(`/schedule`, {params: payload, headers: headers})
// export const updateSchedule = (id, payload) => api.put(`/schedule/${id}`, payload, {headers: headers})
// export const deleteSchedule = id => api.delete(`/schedule/${id}`, {headers: headers})
// export const massSchedule = payload => api.put('/schedules/many', payload, {headers: headers})

// Alerts
export const getAlerts = payload => api.get(`/alerts/`, {params: payload, headers: headers})
export const createAlert = payload => api.post(`/alert`, payload, {headers: headers})
export const getAlert = payload => api.get(`/alert`, {params: payload, headers: headers})
export const updateAlert = (id, payload) => api.put(`/alert/${id}`, payload, {headers: headers})
export const deleteAlert = id => api.delete(`/alert/${id}`, {headers: headers})
export const deleteAlerts = payload => api.delete('/alerts/', {params: payload, headers: headers})

// Feedback
export const getFeedbacks = payload => api.get(`/feedback/`, {params: payload, headers: headers})
export const createFeedback = payload => api.post(`/feedback`, payload, {headers: headers})

// Integrations
export const getWorkflow = id => clientAPI.get(`/workflow/${id}`, {headers: headers})
export const createWorkflow = payload => clientAPI.post(`/workflow`, payload, {headers: headers})
export const updateWorkflow = (id, payload) => clientAPI.put(`/workflow/${id}`, payload, {headers: headers})
export const deleteWorkflow = id => clientAPI.delete(`/workflow/${id}`, {headers: headers})
export const getWorkflows = payload => clientAPI.get(`/workflows`, {params: payload, headers: headers})
export const deleteWorkflows = payload => clientAPI.delete(`/workflows`, {data: payload, headers: headers})

// Clients
export const getClients = payload => clientAPI.get(`/tokens`, {params: payload, headers: headers})
export const deleteClient = (id, payload) => clientAPI.delete(`/token/${id}`, { data: payload, headers: headers})
export const getAuthURL = (id, payload) => clientAPI.get(`/auth/${id}`, {params: payload, headers: headers})

// Client - Google Calendar
export const getGoogleCalendars = payload => clientAPI.get('/google_calendar/calendars', {params: payload, headers: headers})
export const getGoogleCalendarEvents = payload => clientAPI.get('/google_calendar/events/', {params: payload, header: headers})
export const syncGoogleCalendar = payload => clientAPI.post('/google_calendar/channel/sync', payload, {headers: headers})

// Client - Gmail
export const getGmailLabels = payload => clientAPI.get('/gmail/labels', {params: payload, headers: headers})
export const getGmailMessage = payload => clientAPI.get('/gmail/message', {params: payload, headers: headers})

// Client - Telegram
export const sendTele = (id, payload) => clientAPI.post(`/telegram/message/${id}`, payload, {headers: headers})

// Client - Trello
export const getTrelloBoards = payload => clientAPI.get('/trello/boards', {params: payload, headers: headers})
export const getTrelloLists = payload => clientAPI.get('/trello/lists', {params: payload, headers: headers})
export const getTrelloLabels = payload => clientAPI.get('/trello/labels', {params: payload, headers: headers})
export const getTrelloBoardCards = payload => clientAPI.get('/trello/boardCards', {params: payload, headers: headers})
export const syncTrello = payload => clientAPI.post('/trello/channel/sync', payload, {headers: headers})

// Client - Gsheet
export const getSheet = payload => clientAPI.get('/gsheet/sheet', {params: payload, headers: headers})
export const syncGsheet = payload => clientAPI.post('/gsheet/channel/sync', payload, {headers: headers})

// Client - Todoist
export const getTodoistResource = payload => clientAPI.get('/todoist/resource', {params: payload, headers: headers})
export const getTodoistProjectData = payload => clientAPI.get('/todoist/project/data', {params: payload, headers: headers})
export const syncTodoist = payload => clientAPI.post('/todoist/channel/sync', payload, {headers: headers})

// Client - Outlook Calendar
export const getOutlookCalendars = payload => clientAPI.get(`/outlook_calendar/calendars`, { params: payload, headers: headers })
export const getOutlookCalendarEvents = payload => clientAPI.get(`/outlook_calendar/events`, { params: payload, headers: headers })
export const syncOutlookCalendar = payload => clientAPI.post(`/outlook_calendar/channel/sync`, payload, { headers: headers })

// Payments
export const getPaymentIntent = payload => api.get('/payment/paymentIntent', {params: payload, headers: headers})
export const createCheckout = payload => api.get('/payment/checkout', {params: payload, headers: headers})
export const getPaymentMethod = payload => api.get('/payment-method/', {params: payload, headers: headers})
export const updatePaymentMethod = payload => api.put('/payment-method/', payload, {headers: headers})
export const collectPaymentMethod = payload => api.post('/payment-method/', payload, {headers: headers})
export const updateSubscriptionPlan = payload => api.put('/subscription/plan', payload, {headers: headers})
export const updateSubscriptionStatus = payload => api.put('/subscription/status', payload, {headers: headers})

export const getCustomer = id => api.get(`/customer/${id}`, {headers: headers})
export const updateCustomer = payload => api.put('/customer/', payload, {headers: headers})

export const getInvoices = payload => api.get(`/payment/invoices`, {params: payload, headers: headers})

